
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Question} from "@/lib/Question";

    @Component({})
    export default class MrhRoomDetail extends Vue{
        @Prop() public payload: any;

        mounted() {
            this.recalculateDetailsValue();
        }

        increaseRoom() {
            this.payload.content.number++;
            this.payload.content.value = this.payload.content.number * this.payload.content.singleValue;
            this.recalculateDetailsValue();
        }

        decreaseRoom() {
            if(this.payload.content.number === 0){
                return;
            }
            this.payload.content.number--;
            this.payload.content.value = this.payload.content.number * this.payload.content.singleValue;
            this.recalculateDetailsValue();
        }
        public increase(key: any){
            const detail = this.payload.content.details[key];
            detail.number++;
            this.recalculateDetailsValue();
            // detail.value = detail.number * detail.singleValue;
        }
        public decrease(key: any ){
            const detail = this.payload.content.details[key];
            if(detail.number === 0){
                return;
            }
            detail.number--;
            this.recalculateDetailsValue();
            // detail.value = detail.number * detail.singleValue;
        }

        public recalculateDetailsValue() {
            if(this.payload.content.hasOwnProperty('details')){

                let otherDetailValue = parseInt(this.payload.content.value + '');
                let otherKey: number = -1;
                let roomValueChanged = false;
                for(let key in this.payload.content.details){
                    if (this.payload.content.details[key].title === 'other') {
                        otherKey = parseInt(key);
                        continue;
                    }
                    let detailValue = parseInt(this.payload.content.details[key].value + '') ;
                    otherDetailValue = otherDetailValue - detailValue;
                    let detailNumber = parseInt(this.payload.content.details[key].number + '');
                    if (detailNumber === 0 && detailValue > 0) {
                        this.payload.content.details[key].number = 1;
                    }
                    if (otherDetailValue < 0) {
                        this.payload.content.value = parseInt(this.payload.content.value + '')  + ( otherDetailValue * -1 );
                        otherDetailValue = 0;
                        roomValueChanged = true;
                    }
                }

                if(otherKey != -1){
                    this.payload.content.details[otherKey].value = otherDetailValue;
                }
                if (otherDetailValue > 0 && this.payload.content.details[otherKey].number === 0) {
                    this.payload.content.details[otherKey].number = 1;
                }
                this.updatePropertyValue();

            }
        }

        public updatePropertyValue() {
            const question = this.$store.state.questions.find((question: Question) => question.id === 35 );
            if (question) {
                question.extraEvent.emit('detailsChanged');
            }
        }

        public initRoomNumber() {
            if (this.payload.content.value > 0 && this.payload.content.number === 0) {
                this.payload.content.number = 1;
                this.updatePropertyValue();
            }
        }
    }
